export default "__VITE_ASSET__Dj4zt83K__"